import { FC, forwardRef, memo, useCallback } from 'react'
import { format } from 'date-fns'
import { TypeBadge } from '../TypeBadge/TypeBadge'
import { LPTd, MessageTimelineTableRow } from './styled'
import { GoTriangleLeft, GoTriangleRight } from 'react-icons/go'
import { TruncatedTableCell } from '../../../fix-session-manager/components/common/TruncatedTableCell'

interface Props {
    index: number
    data: Record<string, any>
    isSearch: boolean | undefined
    isSelected: boolean
    isEven: boolean
    isTruncate: boolean
    isAppeared: boolean
    onRowSelect: (index: number) => void
}

const isEqual = (prevProps: Props, nextProps: Props) => {
    if (
        prevProps.isSelected !== nextProps.isSelected ||
        prevProps.data !== nextProps.data ||
        prevProps.isSearch !== nextProps.isSearch ||
        prevProps.isTruncate !== nextProps.isTruncate
    ) {
        return false
    }
    return true
}

const TruncatedTd = TruncatedTableCell(LPTd)

export const TimelineTableRow: FC<Props> = memo(
    forwardRef(({ index, data, isSearch, isSelected, isEven, isTruncate, isAppeared, onRowSelect }, ref) => {
        const {
            sendingTime,
            senderCompID,
            senderSubID,
            targetCompID,
            msgType_Desc,
            clOrdID,
            orderQty,
            symbol,
            side,
            rw,
            text,
            seqNumber
        } = data

        const onRowSelectCallback = useCallback(() => onRowSelect(index), [index, onRowSelect])

        const isError = data?.status?.includes('parse-error')

        return (
            // @ts-ignore
            <MessageTimelineTableRow
                onClick={onRowSelectCallback}
                isAppeared={isAppeared}
                isSelected={isSelected}
                isEven={isEven}
                ref={ref}
                size="sm"
            >
                <LPTd>
                    {isError ? (
                        <span style={{ fontWeight: 800 }}>ERROR</span>
                    ) : (
                        sendingTime && format(new Date(sendingTime), 'HH:mm:ss.SSS')
                    )}
                </LPTd>
                {isSearch && <LPTd>{rw === 'R' ? <GoTriangleLeft style={{ margin: 'auto' }} /> : <GoTriangleRight  style={{ margin: 'auto' }} />}</LPTd>}
                <TruncatedTd isTruncate={isTruncate} isEven={isEven} isSelected={isSelected}>{senderCompID}</TruncatedTd>
                <TruncatedTd isTruncate={isTruncate} isEven={isEven} isSelected={isSelected}>{targetCompID}</TruncatedTd>
                <LPTd>{!!msgType_Desc && <TypeBadge type={msgType_Desc} />}</LPTd>
                <TruncatedTd isTruncate={isTruncate} isEven={isEven} isSelected={isSelected}>{clOrdID}</TruncatedTd>                                
                <LPTd>
                    {
                    isError ? (
                        <span>Click this row for details</span>
                    ) : 
                    (msgType_Desc === 'NewOrderSingle' || msgType_Desc === 'OrderCancelRequest') &&
                        orderQty &&
                        symbol &&
                        side && (
                            <div
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    fontSize: '8px'
                                }}
                            >
                                <TypeBadge type={side === '1' ? 'BUY' : 'SELL'} />
                                <p style={{ marginRight: '10px' }}>{orderQty}</p>
                                <TypeBadge type={symbol.toUpperCase()} />
                            </div>
                        )}
                    {msgType_Desc === 'Reject' && <div>{text}</div>}
                    {msgType_Desc === 'ExecutionReport' && <div>{data.ordStatus_Desc}</div>}
                </LPTd>
            </MessageTimelineTableRow>
        )
    }),
    isEqual
)
